var FIGURE = FIGURE || {};

// Which ink the things parked over a category page are wearing.
//
// Two of them ask the same question of the same boxes: the sticky "All Notes" link in the left
// gutter, and the site header, which is fixed and passes over the same photographs on its way down
// the page. Whatever happens to be behind either one changes as the page moves — the page's white
// through most of it, a full-bleed note's photograph wherever one passes underneath. Dark ink on the
// first, light on the second, and nothing in CSS can tell the two apart: a container query cannot see
// a sibling, and neither element has an ancestor worth querying. So the overlap is measured. See the
// note above .notes-category-back in _notes-category.scss for what was tried instead.
//
// Only full-bleed notes are marked, and deliberately so. Their media runs the full width of the page
// and their own copy is already set in white over it, so light ink there is the same decision the
// design has already made. A photo sitting in one of the text columns is not a backdrop for anything —
// on a wide viewport it never reaches the gutter the link sits in, and below sm, where it does grow to
// the full width, flipping over it would put a white link on a pale photo and then back again a
// screen later.
//
// Both axes are still measured. With only full-width boxes marked, the horizontal test can never fail
// on its own — it is there so that marking something column-shaped later behaves rather than surprises.
FIGURE.notesBack = function () {
    var scope = document.querySelector('main') || document.body;
    var media = scope.querySelectorAll('[data-notes-media]');
    if (!media.length) return;

    // Held in document coordinates so the scroll handler reads one set of rects rather than one per
    // target. Recomputed when the layout moves rather than per frame — an image arriving late, a
    // webfont settling, a resize — which is what the observer below is for.
    var boxes = [];

    function measure() {
        boxes = Array.prototype.map.call(media, function (el) {
            var r = el.getBoundingClientRect();
            return {
                top: r.top + window.scrollY,
                bottom: r.bottom + window.scrollY,
                left: r.left + window.scrollX,
                right: r.right + window.scrollX
            };
        });
    }

    // Each target reports its own box in document coordinates, because the two do not agree on how to
    // find it — see the header's own note below.
    var targets = [];

    document.querySelectorAll('[data-notes-back]').forEach(function (link) {
        targets.push({
            el: link,
            over: null,
            box: function () {
                var r = link.getBoundingClientRect();
                return {
                    top: r.top + window.scrollY,
                    bottom: r.bottom + window.scrollY,
                    left: r.left + window.scrollX,
                    right: r.right + window.scrollX
                };
            }
        });
    });

    var header = document.querySelector('.site-header');

    if (header) {
        targets.push({
            el: header,
            over: null,
            // Where the header sits when it is showing, not where it is at this instant. It leaves the
            // page by being translated upward and a rect includes that translate, so measuring one
            // would answer for a box up off the top of the screen — and since the answer is only
            // recomputed on scroll, the wrong ink would be the one showing at the moment it slid back
            // into view. Its resting box is fixed and knowable instead: the `top` the stylesheet gives
            // it plus its own height, neither of which a transform touches.
            box: function () {
                var top = (parseFloat(window.getComputedStyle(header).top) || 0) + window.scrollY;
                return {
                    top: top,
                    bottom: top + header.offsetHeight,
                    left: window.scrollX,
                    right: window.scrollX + header.offsetWidth
                };
            }
        });
    }

    function update() {
        for (var t = 0; t < targets.length; t++) {
            var target = targets[t];
            var b = target.box();
            var hit = false;

            for (var i = 0; i < boxes.length; i++) {
                var m = boxes[i];
                // Strict inequalities, so merely touching an edge is not an overlap: the notes are
                // stacked flush, and >= would put a target in both of two adjacent boxes at once.
                if (m.bottom > b.top && m.top < b.bottom && m.right > b.left && m.left < b.right) {
                    hit = true;
                    break;
                }
            }

            if (hit === target.over) continue;
            target.over = hit;
            target.el.classList.toggle('is-over-media', hit);
        }
    }

    // One update per frame at most. A scroll fires far more often than it paints, and the answer
    // cannot change between two paints of the same frame.
    var queued = false;

    function onScroll() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
            queued = false;
            update();
        });
    }

    function remeasure() {
        measure();
        update();
    }

    remeasure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure);
    // Images carry width/height hints, so the layout is mostly settled before they arrive — but
    // only mostly, and a note whose image loads late moves every box below it.
    window.addEventListener('load', remeasure);

    if (window.ResizeObserver) {
        // Catches what the two events above do not: a lazy image resolving, a webfont reflowing
        // the copy, anything else that moves the notes without moving the window. Safe against a
        // feedback loop because update() only ever changes a class that paints.
        new window.ResizeObserver(remeasure).observe(scope);
    }
}();
